import React from 'react';
import useTopBannerRegistration from '~/hooks/use-top-banner-registration';
import FormattedMessageWrapper from '../FormattedMessageWrapper/FormattedMessageWrapper';
import { OFFLINE_BANNER_HEIGHT } from './styled';
import * as S from './styled';

const OfflineBanner = () => {
  useTopBannerRegistration(OFFLINE_BANNER_HEIGHT);

  return (
    <S.Banner>
      <h3>
        <FormattedMessageWrapper langKey="web.error.user_offline" />
      </h3>
    </S.Banner>
  );
};
export default OfflineBanner;
